/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Supported date range presets for report widgets.
 */
export enum ReportDateRangePreset {
    TODAY = 'TODAY',
    LAST_7_DAYS = 'LAST_7_DAYS',
    THIS_MONTH = 'THIS_MONTH',
    LAST_30_DAYS = 'LAST_30_DAYS',
    CUSTOM_RANGE = 'CUSTOM_RANGE',
}
